import { Outlet } from 'react-router-dom'
import { Container, Row, Col } from 'react-grid-system'
import ManageSideNav from './components/ManageSideNav'
import Nav from '../../components/nav/Nav'

function Manage() {
  return (
    <Container fluid>
      <Nav />
      <Row>
        <Col md={2}>
          <br />
          <ManageSideNav />
        </Col>
        <Col md={10}>
          <br />
          <Outlet />
        </Col>
      </Row>
    </Container>
  )
}

export default Manage
